<template>
  <section>
    <div class="section section-header section-row div-5">
      <div>Tickets</div>
      <div>Section</div>
      <div class="right-field">
        Price
      </div>
      <div class="right-field">
        Projected Tickets&nbsp;Sold
      </div>
      <div class="right-field">
        Amount
      </div>
    </div>
    <template
      v-for="(row, index) in ticketsRows"
      :key="row._formId"
    >
      <TicketsRowForm
        :form-id="row._formId"
        :initial-values="(tickets && tickets[index]) || {}"
        :total="row.total"
        :disabled="loading"
        class="section section-row div-5 with-border"
        @blur="onTicketRowBlur(row._formId)"
        @save="onRowSave(row._formId)"
        @clear="onRowDelete(row._formId)"
      />
    </template>
    <div class="section section-row div-5 bold">
      <div class="triple-f">
        GBOR
      </div>
      <div class="right-field">
        {{ ticketsSoldGbor }}
      </div>
      <div class="right-field overflow-x-auto">
        {{ formatCurrency(totalGbor, { onZero: '-' }) }}
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useOfferSheetStore } from '@/stores/offer-sheet';
import { useOfferSheetFormStore } from '@/stores/offer-sheet-form';
import { useFormsStore } from 'vuniform';
import TicketsRowForm from './TicketsRowForm.vue';
import { formatCurrency } from '@/helpers/currency';
import type { UpsertTicketInput } from '@/generated/graphql';

interface Props {
  formIdPrefix: string;
}
defineProps<Props>();

const offerSheetStore = useOfferSheetStore();
const formsStore = useFormsStore();
const tickets = computed(() => offerSheetStore.offerSheet?.tickets);
const loading = computed(() => offerSheetStore.ticketsLoading);
const offerSheetFormStore = useOfferSheetFormStore();

const ticketsRows = computed(() => offerSheetFormStore.ticketsRows);

const onTicketRowBlur = (key: string) => {
  onRowSave(key);
};

const totalGbor = computed(() => offerSheetFormStore.ticketsTotalGBOR);

const ticketsSoldGbor = computed(() => offerSheetFormStore.projectedTicketsSoldTotal);

const deleteRow = (formId: string) => {
  offerSheetFormStore.deleteTicketRow(formId);
};

const onRowDelete = async (formId: string) => {
  const id = formsStore.fieldGetValue(formId, 'id');
  if (!id) {
    return;
  }

  await offerSheetStore.deleteTicket(id);

  deleteRow(formId);
};

const onRowSave = async (formId: string) => {
  if (loading.value || !formsStore.isFormDirty(formId)) {
    return;
  }

  const payload = formsStore.formGetValues<UpsertTicketInput>(formId);
  payload.offerSheetId = offerSheetStore.offerSheet.id;
  payload.projected = +payload.projected;
  payload.clientMutationId = formId;

  const ticket = await offerSheetStore.upsertTicket(payload);

  formsStore.SET_INITIAL_VALUES({
    values: { ...ticket },
    formId,
    clearDirty: true,
  });

  formsStore.RESET_FIELD_VALUES(formId);
};
</script>
